import { render, staticRenderFns } from "./WorkspaceExplainGraphModal.vue?vue&type=template&id=7f408d54&scoped=true"
import script from "./WorkspaceExplainGraphModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceExplainGraphModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExplainGraphModal.vue?vue&type=style&index=0&id=7f408d54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f408d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f408d54')) {
      api.createRecord('7f408d54', component.options)
    } else {
      api.reload('7f408d54', component.options)
    }
    module.hot.accept("./WorkspaceExplainGraphModal.vue?vue&type=template&id=7f408d54&scoped=true", function () {
      api.rerender('7f408d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExplainGraphModal.vue"
export default component.exports